import { jsx as _jsx } from "react/jsx-runtime";
import { CodeListing, Prose } from '@criteria-labs/react-typography';
export function EndpointsFigure({ resource }) {
    const code = resource.endpoints
        .map((endpoint) => { var _a; return `${endpoint.method.toUpperCase().padStart(6, ' ')} ${(_a = endpoint.path) !== null && _a !== void 0 ? _a : '/callback'}`; })
        .join('\n');
    return (_jsx(Prose, { className: "max-w-none", children: _jsx(CodeListing, { code: code, title: "Endpoints" }) }));
}
